import { PagedRequest } from './paged-request.model';
import { SortDirection } from '../enums/sort-direction.enum';
import { ConsolGridOrderBy } from './consol-grid-order-by.enum';

export class ConsolListFilterRequest extends PagedRequest {
  public SortColumn: ConsolGridOrderBy;
  public SortDirection: SortDirection;
  public MasterBillNumber: string;
  public ContainerNumber: string;
  public HouseBillNumber: string;
  public CustomerRefNumber: string;
  public ConsigneeName: string;
  public ShipmentCode: string;
  public SearchFrom?: string;
  public OrganizationCode: string;
}
